export class Car {
  plateNumber: string
  constructor(json: any) {
    this.plateNumber = json.plateNumber
  }
}
